import { useEffect } from "react";

import CareerPlusWebSliderSection from "../../components/pages/Index/CareerPlusWebSliderSection";
import SlideBannerSection from "../../components/pages/Index/SlideBannerSection";
import FooterSection from "../../components/pages/Index/FooterSection";
import ContactForm from "../../components/pages/Contact/ContactForm";

import sliderImage from "../../assets/images/CareerPlus-KV-Web-Slider-Contact.svg";
import Loading from "../../components/pages/Index/Loading";

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ paddingTop: "95px" }}>
      <Loading />
      <CareerPlusWebSliderSection image={sliderImage} />
      <ContactForm />
      <SlideBannerSection />
      <FooterSection />
    </div>
  );
};

export default Contact;
